import "@lottiefiles/lottie-player"
import upsell from "../upsell"

export default (getView) => (nextStepPath) => ({
  ...getView(nextStepPath),
  ...upsell(),

  statusToTrack: "PURCHASE",

  onInit() {
    this.store.savePurchasedBasicOffer()
  },
})
